module.exports = __webpack_public_path__ + "static/media/report-bug-circles.2871990a.png";